<template>
    <div>
        <div class="map-frame">
            <div class="google-map" id="google-map"></div>
        </div>
    </div>
</template>
<script>
import Gmaps from './GoogleMaps';
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'app-google-map',
    props: {
        'mapName': {
            type: String,
            default() {
                return 'Doma';
            }
        },
        'glat': {
            type: String,
            default() {
                return '';
            }
        },
        'glng': {
            type: String,
            default() {
                return '';
            }
        },
        'zoom': {
            type: Number,
            default() {
                return 15;
            }
        }
    },

    data() {
        return {
            //
        }
    },
    computed: {
        ...mapGetters([
            'loading',
            'error',
            'lat',
            'lng',
        ]),
    },

    methods: {
        ...mapActions([
            'setLat',
            'setLng'
        ]),
        setLat() {
            if(this.glat !== '' || this.glat !== undefined) {
                this.$store.dispatch('setLat',this.glat);
            }
        },
        setLng() {
            if(this.glng !== '' || this.glng !== undefined) {
                this.$store.dispatch('setLng',this.glng);
            }
        }
    },
    // For dropdown locations
    mounted() {
        let opt = {
            lat: this.lat,
            lng: this.lng,
            zoom: this.zoom,
            name: this.mapName
        }
        let gmaps = new Gmaps(opt);
        // console.log('Gmap mounted: ', this.lat, this.lng, ' end', this.glat, this.glng);
        gmaps.drawMap();
    },

    // For images location (AlbumLocation) - links on images (home)
    beforeUpdate() {
        let opt = {
            lat: this.lat,
            lng: this.lng,
            zoom: this.zoom,
            name: this.mapName
        }
        let gmaps = new Gmaps(opt);
        gmaps.drawMap();
        // console.log('Gmap beforeUpdate: ', this.lat, this.lng, this.glat, this.glng);
    }
};

</script>
<style scoped>
html, body {
    width: 100%;
    height: 100%;
}
.map-frame {
    width: 100%;
    height: 400px;
    position: relative;
    margin-top: 50px;
}


.google-map {
    width:100% !important;
   height:400px !important;
   top:0px !important;
   left:0px !important;
   position: absolute !important; /*works with static, if fixed -then whole page*/
    min-width: 600px;
    min-height: 450px;
    margin: 0 auto;
    background: gray;
    max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/gmaps/GoogleMaps.vue